import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.field',
    modules: [
        R,
    ],
})
@Service('FieldStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('fields');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/field.js